import { SpatialDatasetProcessingStatus, SpatialDatasetSourceFormat } from "../types";

/** Chunk size for multipart uploads — backend rejects any other size. */
export const SPATIAL_DATASET_CHUNK_SIZE = 10 * 1024 * 1024; // 10 MB exactly

/** Only the layer id for the single active spatial overlay. */
export const SPATIAL_ACTIVE_LAYER_ID = "spatial-active";

export const SPATIAL_DATASET_POLL_INTERVAL_MS = 3_000; // 3 s

/** Maps file extension (lower-cased, no dot) → source_format sent to the API. */
export const EXTENSION_TO_SOURCE_FORMAT: Record<string, SpatialDatasetSourceFormat> = {
  tif: "geotiff",
  tiff: "geotiff",
  gpx: "gpx",
  geojson: "geojson",
  json: "geojson",
  kml: "kml",
  kmz: "kml",
  csv: "csv",
  // .zip is the browser-visible extension for Shapefile (.shp.zip) bundles.
  // The backend expects a zip containing .shp + sidecars; source_format must be "shapefile".
  zip: "shapefile"
};

/** Dropzone accept map — extensions the spatial upload mode allows. */
export const SPATIAL_DATASET_ACCEPTED_FILES: Record<string, string[]> = {
  "image/tiff": [".tif", ".tiff"],
  "application/zip": [".zip"],
  "application/gpx+xml": [".gpx"],
  "application/geo+json": [".geojson", ".json"],
  "application/vnd.google-earth.kml+xml": [".kml", ".kmz"],
  "text/csv": [".csv"]
};

/** MIME type sent with the S3 presigned PUT for each source format. */
export const SOURCE_FORMAT_MIME: Record<SpatialDatasetSourceFormat, string> = {
  geotiff: "image/tiff",
  shapefile: "application/zip",
  gpx: "application/gpx+xml",
  geojson: "application/geo+json",
  kml: "application/vnd.google-earth.kml+xml",
  csv: "text/csv"
};

export const SOURCE_FORMAT_LABEL: Record<SpatialDatasetSourceFormat, string> = {
  geotiff: "GeoTIFF",
  shapefile: "Shapefile (.shp.zip)",
  gpx: "GPX",
  geojson: "GeoJSON",
  kml: "KML / KMZ",
  csv: "CSV (tabular)"
};

/**
 * Maps processing_status → human-readable tile label.
 * Used by TileStatusOverlay and the DataListView status chip.
 */
export const SPATIAL_STATUS_TILE_LABEL: Record<SpatialDatasetProcessingStatus, string> = {
  pending: "Pending",
  uploading: "Uploading",
  queued: "Queued",
  processing: "Processing…",
  completed: "Completed",
  failed: "Processing Failed"
};
